import React from 'react'
import { ReactNode } from 'react'

import { cn } from '../../../shadcn/utils'

type VerticalSplitLayoutProps = {
  leftContent?: ReactNode
  rightContent?: ReactNode
  classNames?: {
    container?: string
    left?: string
    right?: string
  }
}

export const VerticalSplitLayout = ({
  leftContent,
  rightContent,
  classNames,
}: VerticalSplitLayoutProps) => {
  return (
    <div className={cn('flex flex-1', classNames?.container)}>
      <div className={cn('flex-1', classNames?.left)}>{leftContent}</div>
      <div className={cn('flex-1', classNames?.right)}>{rightContent}</div>
    </div>
  )
}
